import { IMerchandiseResponse } from './interfaces/merchandise.interfaces';
import { ApiService } from '../shared/services/api-service/api.service';

/**
 * @ignore
 */
declare const TCCommonService;

class Merchandise {
    async getAdvertisementsDetails(hotelCode: number, languageCode?: string, chainCode?: string, currencyCode?: string,
        enableApiCaching: boolean = false) {
        const cacheKey = 'be_' + TCCommonService.ConfigService.getPlatformType() + '_wc_merchandise_' +
            hotelCode + '_' + languageCode?.toLowerCase() + '_' + chainCode?.toLowerCase();
        if (enableApiCaching) {
            const advertisementDetailsFromCache = TCCommonService.BrowserStorageService.getBrowserStorage({ key: cacheKey });
            if (advertisementDetailsFromCache) {
                return advertisementDetailsFromCache;
            }
        }
        try {
            const merchandiseApiResponse: Response = await ApiService.getAdvertisementsDetails(
                hotelCode, languageCode, chainCode, currencyCode);
            const merchandiseObject: IMerchandiseResponse[] = await merchandiseApiResponse.json();
            if (enableApiCaching) {
                TCCommonService.BrowserStorageService.setBrowserStorage({ key: cacheKey, value: merchandiseObject });
                TCCommonService.CacheTrackingService
                    .setCacheTracking({ key: 'advertisementDetails', value: cacheKey });
            }
            return merchandiseObject;
        } catch (errorResponse) {
            throw errorResponse;
        }
    }

    async getAdvertisementById(hotelCode: number, advertisementId: number,
        enableApiCaching: boolean = false) {
        const cacheKey = 'be_' + TCCommonService.ConfigService.getPlatformType() + '_wc_merchandise_' +
            hotelCode + '_advertisementId_' + advertisementId;
        if (enableApiCaching) {
            const advertisementDetailsFromCache = TCCommonService.BrowserStorageService.getBrowserStorage({ key: cacheKey });
            if (advertisementDetailsFromCache) {
                return advertisementDetailsFromCache;
            }
        }
        try {
            const merchandiseApiResponse: Response = await ApiService.getAdvertisementById(
                hotelCode, advertisementId);
            const merchandiseObject: IMerchandiseResponse = await merchandiseApiResponse.json();
            if (enableApiCaching) {
                TCCommonService.BrowserStorageService.setBrowserStorage({ key: cacheKey, value: merchandiseObject });
                TCCommonService.CacheTrackingService
                    .setCacheTracking({ key: 'advertisementById', value: cacheKey});
            }
            return merchandiseObject;
        } catch (errorResponse) {
            throw errorResponse;
        }
    }
}

export const MerchandiseService = new Merchandise();
